module.exports = __webpack_public_path__ + "static/img/kwh_content_bg2.47df1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_content_bg2.png
// module id = Gw6W
// module chunks = 1